import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '@core/auth/auth-guard.service';
import { VinculoListComponent } from './pages/vinculo-list/vinculo-list.component';
import { RouteAction } from '@core/action/action';
import { VinculoFormComponent } from './pages/vinculo-form/vinculo-form.component';
import { RoleEnum } from '@core/models/role';

const routes: Routes = [

  {
    path: '',
    component: VinculoListComponent,
    canActivate: [AuthGuardService],
    data: {
      acao: RouteAction.Visualizar
    },
  },
  {
    path: 'incluir',
    component: VinculoFormComponent,
    data: {
      acao: RouteAction.Inserir,
      permissions: {
        only: [RoleEnum.VinculoGravacao],
        redirectTo: '/acessoNaoPermitido'
      }
    },
  },
  {
    path: 'editar/:id',
    component: VinculoFormComponent,
    data: {
      acao: RouteAction.Editar,
      permissions: {
        only: [RoleEnum.VinculoEdicao],
        redirectTo: '/acessoNaoPermitido'
      }
    },
  },
  {
    path: 'visualizar/:id',
    component: VinculoFormComponent,
    data: {
      acao: RouteAction.Visualizar
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VinculoRoutingModule { }
